import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { isSuperAdminUserId } from '../../lib/superAdminIds'

interface Props {
  children: ReactNode
}

/** SUPER_ADMIN_USER_IDS — platform billing controls (prod: 22; staging2 adds e2e-admin). */
export default function SuperAdminRoute({ children }: Props) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div className="auth-spinner" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login?next=%2Fadmin%2Fcustomers" replace />
  }

  if (!isSuperAdminUserId(user.id)) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}
